import React from "react";
import "@/index.css";
import PropChainApp from "@/PropChainApp";

export default function App() {
  return <PropChainApp />;
}
